import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiRequests } from "../services/ApiRequest";
import { toast } from "react-toastify";

export const getOnboardingRequests = createAsyncThunk(
  "onboarding/getOnboardingRequests",
  async () => {
    try {
      const response = await ApiRequests.getOnboardingRequests();
      if (response.status === 200) {
        return response?.data?.RESPONSE;
      }
    } catch (error) {
      console.error("Failed to fetch onboarding requests:", error);
    }
  }
);

export const updateOnboardingRequest = createAsyncThunk(
  "onboarding/updateOnboardingRequest",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await ApiRequests.updateOnboardingRequest(id, data);
      if (response.status === 200) {
        toast.success("Onboarding request updated successfully!", {
          position: "top-right",
          autoClose: 3000,
          closeOnClick: true,
          pauseOnHover: true,
          theme: "light",
        });
        dispatch(getOnboardingRequests());
        return response?.data?.RESPONSE;
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.ERROR?.message ||
          "Failed to update onboarding request",
        {
          position: "top-right",
          autoClose: 3000,
          closeOnClick: true,
          pauseOnHover: true,
          theme: "light",
        }
      );
    }
  }
);

export const deleteOnboardingRequest = createAsyncThunk(
  "onboarding/deleteOnboardingRequest",
  async ({ id }, { dispatch }) => {
    try {
      const response = await ApiRequests.deleteOnboardingRequest(id);
      if (response.status === 200) {
        toast.success("Onboarding request deleted successfully!", {
          position: "top-right",
          autoClose: 3000,
          closeOnClick: true,
          pauseOnHover: true,
          theme: "light",
        });
        dispatch(getOnboardingRequests());
        return response?.data?.RESPONSE;
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.ERROR?.message ||
          "Failed to delete onboarding request",
        {
          position: "top-right",
          autoClose: 3000,
          closeOnClick: true,
          pauseOnHover: true,
          theme: "light",
        }
      );
    }
  }
);

const initialState = {
  loading: false,
  allOnboardingRequests: [],
};

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOnboardingRequests.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOnboardingRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.allOnboardingRequests = action.payload;
      })
      .addCase(getOnboardingRequests.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateOnboardingRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateOnboardingRequest.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateOnboardingRequest.rejected, (state) => {
        state.loading = false;
      })

      .addCase(deleteOnboardingRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteOnboardingRequest.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteOnboardingRequest.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default onboardingSlice.reducer;
